<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>{{ $t('detailOrdreTravailTech.bilan.title')}}</p>
    </header>
    <div class="card-content">
     {{ ordreTravail.bilanIntervention }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'LogistiqueOrdreTravailTechniqueDetailBilan',
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
};

</script>
